<template>
	<div id="market_detail">
		<leftnav class="fl"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="25vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<watermark :isShowMark='isshowWaterMark'>
				<div class="index_left_centerpage whitebox">
					<div class="chart-type">
						<div class="charts-title">{{ baseInfo.title }}</div>
						<div class="fl">
							<span v-for="(item, i) in chartTypeList" :key="i"
							:class="chartType == item.value ? 'active' : ''" @click="changeChartType(item)">{{
								item.label }}</span>
						</div>
						<div class="deeseek-tips fr width"><i class="orgfont">让deepseek做{{this.baseInfo.title}}分析：</i> 
							<em class="curp" @click="goAIChart(1)">快速分析 >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</em>
							<em class="curp" @click="goAIChart(2)">深度分析 ></em> 
						</div>
					</div>
					<div class="mt-3 pb-3 download-position">
						<div @click="downloadPng" class="downloadPng"><i class="el-icon-download font-30 color-c4"
								title="保存为图片"></i></div>
						<div id="chart-download">
							<div id="baseInfoCharts" class="mt-6"></div>
							<p class="widthPC-75 margin-x-auto">数据来源：中投顾问产业大脑</p>
						</div>
					</div>
					<div class="whitebox company-investinfor"
						v-show="pageType == 1 ? market.length > 0 : compete.length > 0">
						<div class=" d_blocktitle d-floortitle pt-3">
							<i class="title-icon title-icon3"></i>
							<h3 class="title">{{ pageType == 1 ? '关联市场规模' : '关联竞争格局' }}</h3>
						</div>
						<div class="market-box w95mg oh">
							<div v-for="(list, i) in pageType == 1 ? market : compete" :key="i"
								class="fl market-list mb-2">
								<h4 class="mt-1 market-title"
									@click="routerblank('/marketDetail?id=' + list.id + '&type=' + (pageType == 1 ? 1 : 2))">
									{{ list.title }}</h4>
								<div style="width: 90%;height: 290px;margin: 0 auto;"
									:id="pageType == 1 ? 'bar_charts_' + i : 'pie_charts_' + i"></div>
							</div>
						</div>
					</div>
					<div class="whitebox company-investinfor"
						v-show="pageType == 1 ? compete.length > 0 : market.length > 0">
						<div class=" d_blocktitle d-floortitle pt-3">
							<i class="title-icon title-icon3"></i>
							<h3 class="title">{{ pageType == 1 ? '关联竞争格局' : '关联市场规模' }}</h3>
						</div>
						<div class="market-box w95mg oh">
							<div v-for="(list, i) in pageType == 1 ? compete : market" :key="i"
								class="fl market-list mb-2">
								<h4 class="mt-1 market-title"
									@click="routerblank('/marketDetail?id=' + list.id + '&type=' + (pageType == 1 ? 2 : 1))">
									{{ list.title }}</h4>
								<div style="width: 90%;height: 290px;margin: 0 auto;"
									:id="pageType == 1 ? 'pie_charts_' + i : 'bar_charts_' + i"></div>
							</div>
						</div>
					</div>
					<div class="whitebox company-investinfor" v-show="product.length > 0">
						<div class=" d_blocktitle d-floortitle pt-3">
							<i class="title-icon title-icon3"></i>
							<h3 class="title">关联产品产量</h3>
						</div>
						<div class="market-box w95mg oh">
							<div v-for="(list, i) in product" :key="i" class="fl market-list mb-2">
								<h4 class="mt-1 market-title">{{ list.title }}</h4>
								<div style="width: 90%;height: 290px;margin: 0 auto;" :id="'cp_charts_' + i"></div>
							</div>
						</div>
					</div>
					<div class="whitebox company-investinfor" v-show="chain.length > 0">
						<div class=" d_blocktitle d-floortitle pt-3">
							<i class="title-icon title-icon3"></i>
							<h3 class="title">关联产业链</h3>
						</div>
						<div class="market-box w95mg oh">
							<div v-for="(list, i) in chain" :key="i" class="fl market-list mb-2"
								@click="routerblank('/chain?id=' + list.chainId)">
								<h4 class="mt-1 market-title">{{ list.chainName }}</h4>
								<img class="market-chain-img" style="display:block ;" :src="list.image"
									:alt="list.chainName">
							</div>
						</div>
					</div>
					<div class="whitebox company-investinfor" v-show="showTable">
						<div class=" d_blocktitle d-floortitle pt-3">
							<i class="title-icon title-icon3"></i>
							<h3 class="title">关联产业数据</h3>
						</div>
						<industryChart :isChain="false" :industryList="industry" v-if="showTable"></industryChart>
					</div>
					<div class="whitebox company-investinfor" v-show="landList.length > 0">
						<div class=" d_blocktitle d-floortitle pt-3">
							<i class="title-icon title-icon3"></i>
							<h3 class="title">关联拿地投资项目</h3>
						</div>
						<land :isChain="false" :landList="landList"></land>
					</div>
					<div class="whitebox company-investinfor" v-show="investList.length > 0">
						<div class=" d_blocktitle d-floortitle pt-3">
							<i class="title-icon title-icon3"></i>
							<h3 class="title">关联上市公司投资项目</h3>
						</div>
						<invest :isChain="false" :investList="investList"></invest>
					</div>
					<div class="whitebox company-investinfor pb-3" v-show="enterprise.length > 0">
						<div class=" d_blocktitle d-floortitle pt-3">
							<i class="title-icon title-icon3"></i>
							<h3 class="title">关联企业融资项目</h3>
						</div>
						<table class="enterprise_table" border="0" cellspacing="0" cellpadding="0">
							<tr>
								<th>序号</th>
								<th>企业名称</th>
								<th>城市</th>
								<th>注册资金</th>
								<th>融资轮次</th>
								<th>融资时间</th>
								<th>融资金额</th>
							</tr>
							<tr :key="i" v-for="(list, i) in enterprise">
								<td>{{ i + 1 }}</td>
								<td class="fwb curp" style="min-width: 145px;"
									@click="routerlinkid('/enterprises', list.stockCode, 2, '', 'leading')">{{
										list.title }}
								</td>
								<td>{{ list.area }}</td>
								<td>{{ list.regCapital == '' ? '-' : list.regCapital }}</td>
								<td v-html="list.financingRound.length > 0 ? list.financingRound[0].rount : '-'"></td>
								<td v-html="list.financingRound.length > 0 ? list.financingRound[0].time : '-'"></td>
								<td v-html="list.financingRound.length > 0 ? list.financingRound[0].amount : '-'"></td>
							</tr>
						</table>
					</div>
				</div>
			</watermark>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import industryChart from './chaindetail-inc/industry.vue'
import land from './chaindetail-inc/land.vue'
import invest from './chaindetail-inc/invest.vue'
import { sortKey } from '@/utils/index.js'
import html2canvas from "html2canvas"
export default {
	// name: 'marketDetail',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	components: {
		industryChart, land, invest
	},
	data() {
		return {
			userdata: {},
			pageType: 1,
			id: '',
			baseInfo: {},
			compete: [],
			market: [],
			product: [],
			landList: [],
			investList: [],
			industry: [],
			enterprise: [],
			chain: [],
			showTable: false,
			isshowWaterMark: false, //是否显示水印
			isShowFreeUserTips: false, //是否显示免费用户提示
			freeUserType: 2,
			chartType: 1,
			chartTypeList: [
				{ label: '折柱混合', value: 1 },
				{ label: '柱状图', value: 7 },
				{ label: '折线', value: 2 },
				{ label: '弧线', value: 5 },
				{ label: '面积', value: 6 },
				{ label: '饼图', value: 3 },
				// { label: '雷达', value: 4 }
			],
			mychart: null,
			dataMap: []
		}
	},
	beforeCreate() { },
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
		});
		this.userdata = this.getuseriformation();
		this.id = this.$route.query.id;
		this.pageType = this.$route.query.type;
	},
	mounted() {
		window.scrollTo(0, 0);
		window.addEventListener("scroll", this.handleScroll, true);
		this.getPageDetail();
		if (this.userdata.groupType != 1) { //1正式 2免费 0试用
			this.isshowWaterMark = true;
		}
	},
	methods: {
		goAIChart(model) {
			if(!this.userdata.token){
				this.isShowFreeUserTips = true;
				return;
			}
			//存储到本地存储，每次点击覆盖前面的数据
			let aistitle = '分析';
			let jsonData = {
				title: this.baseInfo.title + aistitle,
			};
			console.log(jsonData);
			localStorage.setItem('aiChatData', JSON.stringify(jsonData));
			let type = this.pageType == 1 ? 4 : 5;
			this.routerblank('/aiChat?id='+this.id+'&model='+model+'&type='+type);
		},
		// 切换图表类型
		changeChartType(item) {
			this.chartType = item.value;
			if (this.chartType == 1) {
				this.drawShape('baseInfoCharts', this.baseInfo.dataList, this.baseInfo.legendName, this.baseInfo.unit, 'show');
			} else if (this.chartType == 7) {
				this.barChart('baseInfoCharts', this.dataMap, this.baseInfo.unit, 'show');
			} else {
				this.chekChartType('baseInfoCharts', this.baseInfo.dataList, this.baseInfo.legendName, this.baseInfo.unit);
			}
		},
		chekChartType(el, data, legendName, unit) {
			console.log(this.chartType, this.baseInfo.unit);
			// console.log(el, data, legendName, unit);
			let xAxisText = [];
			let barData = [], //柱状,
				lineData = []; //折线
			if (this.dataMap && Object.keys(this.dataMap).length > 0 && Object.keys(this.dataMap).every(key => key.trim() !== '') && !Array.isArray(data)) {
				// 遍历 dataMap
				let yAxisIndex = 0;
				legendName = [];
				for (const key in this.dataMap) {
					if (this.dataMap.hasOwnProperty(key)) {
						const dataList = this.dataMap[key];
						legendName.push(key);
						// 提取 label（年份）
						if (yAxisIndex == 0) {
							lineData.push(...dataList.map(item => item.data));
							xAxisText.push(...dataList.map(item => item.label));
						} else if (yAxisIndex == 1) {
							barData.push(...dataList.map(item => item.data));
						}
						yAxisIndex++;
					}
				}

				console.log(xAxisText, lineData, barData, legendName);
			} else {
				for (var i = 0; i < data.length; i++) {
					xAxisText.push(data[i].label);
					barData.push(data[i].value);
					lineData.push(data[i].tb);
				}
			}


			if (this.chartType == 3) {
				this.$nextTick(() => {
					this.pieCharts('baseInfoCharts', this.baseInfo.dataList, this.baseInfo.unit, 'show');
				})
			} else if (this.chartType == 2) {
				this.cpclChart(el, xAxisText, lineData, barData, legendName, unit, false, 0, true);
			}
			else if (this.chartType == 4) {
				this.radarChart(el, data, unit);

			} else if (this.chartType == 5) {
				this.cpclChart(el, xAxisText, lineData, barData, legendName, unit, true, 0, true);
			} else if (this.chartType == 6) {
				this.cpclChart(el, xAxisText, lineData, barData, legendName, unit, false, .5, true);
			}
		},

		downloadPng() {
			if (this.userdata.groupType != 1) {
				this.isShowFreeUserTips = true;
				if (this.userdata.groupType == 2) {
					this.freeUserType = 2;
				} else if (this.userdata.groupType == 0) {
					this.freeUserType = 0;
				}
				return;
			}
			let fileName = this.baseInfo.title;
			// 转换成canvas
			html2canvas(document.getElementById("chart-download")).then(function (canvas) {
				var img = canvas
					.toDataURL("image/png")
					.replace("image/png", "image/octet-stream");
				// 创建a标签，实现下载
				var creatIMg = document.createElement("a");
				creatIMg.download = fileName + ".png"; // 设置下载的文件名，
				creatIMg.href = img; // 下载url
				document.body.appendChild(creatIMg);
				creatIMg.click();
				creatIMg.remove(); // 下载之后把创建的元素删除
			});
		},
		getPageDetail() {
			var that = this;
			this.bus.$emit("loading", true);
			this.$axios.get(this.$api.common.market.detail() + "?id=" + this.id, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				if (res.data.success) {
					console.log(res.data.data);
					let tempData = res.data.data;

					that.baseInfo = tempData.baseinfo;
					document.title = that.baseInfo.title;
					that.market = tempData.market || [];
					that.compete = tempData.compete || [];
					that.dataMap = tempData.baseinfo.dataMap || [];
					let isDataMap = that.dataMap && Object.keys(that.dataMap).every(key => key.trim() !== '');//用来判断是否是新数据，新数据要做特殊处理
					that.$nextTick(() => {
						console.log('isDataMap', isDataMap, that.dataMap.length == 0, Object.keys(that.dataMap).every(key => console.log(key)));
						if (!isDataMap || that.dataMap.length == 0) { //如果没有dataMap数据，就剔除柱状图
							that.chartTypeList = that.chartTypeList.filter(item => {
								return item.value != 7;
							});

						}
						if (Object.keys(that.dataMap).length > 0 && isDataMap) {
							that.baseInfo.dataList = that.dataMap;
						}
						if (that.pageType == 1) {
							if (Object.keys(that.dataMap).length > 0 && isDataMap) {
								that.chartType = 7;
								that.chartTypeList = that.chartTypeList.filter(item => {
									return item.value != 1 && item.value != 3;
								})
								that.barChart('baseInfoCharts', that.dataMap, that.baseInfo.unit, 'show');
							} else {
								that.chartTypeList = that.chartTypeList.filter(item => {
									return item.value != 3
								});
								that.chartType = 1;
								that.drawShape('baseInfoCharts', that.baseInfo.dataList, that.baseInfo.legendName, that.baseInfo.unit, 'show');
							}
						} else {
							that.chartTypeList = that.chartTypeList.filter(item => {
								return item.value != 1;
							});
							that.chartType = 3;
							that.pieCharts('baseInfoCharts', that.baseInfo.dataList, that.baseInfo.unit, 'show');
						}
						that.market.forEach((list, i) => {
							let isFlag = list.dataMap && !Array.isArray(list.dataMap) && Object.keys(list.dataMap).length > 0 && Object.keys(list.dataMap).every(key => key.trim() !== '');
							console.log('isFlag', isFlag, isFlag ? list.dataMap : list.dataList);
							// return;
							that.drawShape('bar_charts_' + i, isFlag ? list.dataMap : list.dataList, list.legendName, list.unit, '');
						})
						that.compete.forEach((list, i) => {
							that.pieCharts('pie_charts_' + i, list.dataList, list.unit);
						})
					})
					if (that.userdata.token) {
						that.getPageDetail2(that.baseInfo.notionCode);
					}
					that.bus.$emit("loading", false);
				} else {
					that.isShowFreeUserTips = true;
					that.bus.$emit("loading", false);
				}
			})
		},
		getPageDetail2(notionList) {
			// console.log('notionList',notionList)
			var that = this;
			this.$axios.get(this.$api.cyl.market.detail2() + "?notionList=" + notionList, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				if (res.data.success) {
					console.log('第二部分', res);
					let tempData = res.data.data;
					that.product = tempData.product;
					that.landList = sortKey(tempData.land, 'time', 1);
					that.investList = sortKey(tempData.invest, 'time', 1);
					that.industry = tempData.industry;
					that.enterprise = tempData.enterprise;
					that.chain = tempData.chain;
					that.sortEeterpise(that.enterprise);
					let data = that.industry;
					for (let i = 0; i < data.length; i++) { // 判断产业数据列表是否有数据
						let item = data[i];
						if (item.data.length > 0) {
							that.showTable = true;
							break;
						}
					}
					that.$nextTick(() => {
						that.product.forEach((list, i) => {
							that.cpclChart('cp_charts_' + i, list.dataList, list.legendName, list.unit);
						})
					})
				} else {

				}
			})
		},
		sortEeterpise(data) {// 使用sort方法对数据进行排序
			data.sort((a, b) => {
				// 确保financingRound数组至少有一个元素
				if (!a.financingRound || !a.financingRound.length) return 1;
				if (!b.financingRound || !b.financingRound.length) return -1;

				// 比较两个时间
				return this.parseDate(b.financingRound[0].time) - this.parseDate(a.financingRound[0].time);
			});
		},
		parseDate(timeStr) {
			let [year, month, day] = []; // 日期格式有 2024.1.2,和2014-1-2两种格式要判断一下
			if (timeStr.indexOf('.') > -1) {
				[year, month, day] = timeStr.split('.').map(num => parseInt(num, 10));
			} else {
				[year, month, day] = timeStr.split('-').map(num => parseInt(num, 10));

			}
			return new Date(year, month - 1, day);
		},
		cpclChart(el, xdata, lineData, barData, legendName, unit, smooth, areaStyleOpacity, bigChart) {
			this.mychart = echarts.init(document.getElementById(el));
			this.mychart.clear();
			let min = Math.floor(Math.min(...barData));
			let max = Math.floor(Math.max(...barData));
			let lineMin = Math.floor(Math.min(...lineData));
			let lineMax = Math.floor(Math.max(...lineData));
			let range = max - min;
			let chartType1 = 'bar';
			let chartType2 = 'line';
			let seriesList = [], legendData = '';
			if (typeof legendName == 'object') {
				legendData = legendName;
			}
			if (bigChart) {
				if (this.chartType == 2 || this.chartType == 5 || this.chartType == 6) {
					chartType1 = 'line';
					chartType2 = 'line';
					if (this.pageType == 1) {
						seriesList = [
							{
								type: chartType1,
								name: typeof legendName == 'object' ? legendName[0] : legendName,
								color: 'rgb(96, 147, 218)',
								yAxisIndex: 0, // 这里指定使用第一个 Y 轴
								data: barData,
								barMaxWidth: 30,
								smooth: smooth,
								areaStyle: { opacity: areaStyleOpacity },
								label: {
									show: true,
									// 绝对的像素值,避免折线数据和柱状数据重叠
									position: [0, -30],
									// position: 'auto',
									formatter: '{c}' + unit,
								}
							},
							{
								name: typeof legendName == 'object' ? legendName[1] : 'YOY',
								type: chartType2,
								yAxisIndex: 1,
								color: '#ffaf25',
								data: lineData,
								smooth: smooth,
								areaStyle: { opacity: areaStyleOpacity },
								label: {
									show: true,
									position: 'auto',
									formatter: '{c}%'
								}
							}
						]
					} else {
						seriesList = [
							{
								type: chartType1,
								name: legendName,
								color: 'rgb(96, 147, 218)',
								yAxisIndex: 0, // 这里指定使用第一个 Y 轴
								data: barData,
								barMaxWidth: 30,
								smooth: smooth,
								areaStyle: { opacity: areaStyleOpacity },
								label: {
									show: true,
									// 绝对的像素值,避免折线数据和柱状数据重叠
									position: [0, -30],
									// position: 'auto',
									formatter: '{c}' + unit,
								}
							},
						]
					}
				}
			}


			min = min - (range / 1)
			// console.log(min,max,range);
			const option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					grid: {
						top: '20%',
					},
					// confine:true, //是否将提示框限制在图表的区域内
					appendToBody: true, //是否将提示框放置在body元素上
					formatter: function (params) {
						// console.log(params);
						var result = ''
						var name = params[0].name + "</br>";
						var dotHtml = '', dotHtml2 = '';
						if (params[0]) {
							dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[0].color + '"></span> ' + params[0].seriesName + "： " + params[0].data + ' ' + unit + "</br>"; // 定义第一个数据前的圆点颜色	
						}
						if (params[1]) {
							dotHtml2 = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[1].color + '"></span>' + params[1].seriesName + "： " + params[1].data + ' %';
						}

						result += name + dotHtml + dotHtml2;
						return result
					},
				},
				legend: {
					show: true,
					bottom: "10",
					itemGap: 30,
					legendData
				},
				xAxis: {
					type: 'category',
					data: xdata,
					interval: 0,
					axisLine: {
						onZero: false,
					}
					// axisLabel: { color: '#333', interval: 0, rotate: 50 }
				},
				yAxis: [
					{
						type: 'value',
						name: '',
						minInterval: 1,
						// min: min,
						boundaryGap: false,
						// step:
						axisTick: {
							"show": true
						},
						axisLine: {
							show: true,
						}, //显示y轴刻度线
						splitLine: {
							show: true
						}, //不显示分割线
					},
					{
						type: 'value',
						name: ' ',
						min: lineMin,
						boundaryGap: false,
						axisTick: {
							"show": true
						},
						splitLine: {
							show: false
						}, //不显示分割线
						axisLine: {
							show: true,
						}, //显示y轴刻度线
						axisLabel: {
							// 使用 formatter 属性来格式化标签文本
							formatter: '{value} %' // 在这里添加单位
						}
					}
				],
				series: seriesList,
			}
			this.mychart.setOption(option)

		},
		pieCharts(el, data, unit, type) {
			var _this = this;
			// console.log(el, data);
			let seriesData = [];
			let temGrid = { top: '20%', bottom: '10%' };
			this.mychart = echarts.init(document.getElementById(el));
			this.mychart.clear();
			for (var i = 0; i < data.length; i++) {
				data[i].name = data[i].label;
				if (data[i].label == '其他') {
					var ortherData = data[i]
					// console.log(data[i]);
				} else {
					seriesData.push(data[i]);
				}
			}
			if (typeof ortherData === 'object' && ortherData !== null && Object.keys(ortherData).length > 0) {
				seriesData.push(ortherData);
				// console.log(ortherData,seriesData,data);
			}
			var option = {
				tooltip: {
					trigger: 'item',
					formatter: '{b0}: {c0}' + unit
				},
				grid: type == "show" ? temGrid : {},
				title: {
					show: type == 'show' ? true : false,
					text: this.baseInfo.title,
					left: 'center',
					top: 10,
					textStyle: {
						fontSize: 20,
					}
				},
				legend: {
					right: type == 'show' ? '10%' : '0',
					top: 'center',
					orient: 'vertical', // 设置图例竖排
					type: 'scroll', //图例强制不换行（滚动）
					width: '70%',
					itemGap: type == 'show' ? 20 : 10,
					formatter: (name) => {
						// console.log(name);
						if (!name) return '';
						let tempStr = this.getEqualNewlineString(name, 10);
						for (let i = 0; i < seriesData.length; i++) {
							// console.log(seriesData[i].name, name);
							if (seriesData[i].name == name && seriesData[i].stockCode != 0) {
								return '{a|' + tempStr + '}'; // 使用{a|text}语法来表示下划线
							} else if (seriesData[i].name == name && seriesData[i].stockCode == 0) {
								return '{b|' + tempStr + '}';

							}
						}
					},
					textStyle: {
						rich: {
							a: {
								color: '#598df5',
								lineHeight: 22,
								align: 'center',
								borderWidth: 0.5,
								fontSize: type == 'show' ? 16 : 12,
								decoration: 'underline' // 设置下划线
							},
							b: {
								fontSize: type == 'show' ? 16 : 12,
							}
						}
					}
				},
				toolbox: { //可视化的工具箱
					show: false,
					itemGap: 30,
					itemSize: 20,
					right: '9%',
					feature: {
						dataView: { //数据视图
							show: false,
							title: '数据视图',
						},
						saveAsImage: {//保存图片
							show: type == 'show' ? true : false,
							title: '保存为图片'
						},
					}
				},
				series: [
					{
						name: '',
						type: 'pie',
						// radius: ['40%', '70%'],
						center: type == 'show' ? ['50%', '55%'] : ['35%', '50%'],
						avoidLabelOverlap: false,
						label: {
							show: type == 'show' ? true : false,
							position: 'outside',
							formatter: '{b}: {c} ' + unit,
							fontSize: 16
						},
						labelLine: {
							show: type == 'show' ? true : false,
						},
						labelLayout: {
							hideOverlap: false // 是否隐藏重叠标签
						},
						minAngle: 15, //最小角度
						// startAngle: 270, //起始角度
						data: seriesData,
						itemStyle: {
							normal: {
								borderColor: '#ffffff', // 发光颜色
								// borderWidth: 5,       // 发光宽度
								// shadowBlur: 10,       // 阴影模糊大小
								// shadowColor: '#f7f3ff'  // 阴影颜色
							}
						},
					}
				],
			};
			this.mychart.setOption(option);
			// 饼图图例点击跳转到指定页面
			this.mychart.on('legendselectchanged', (param) => {

				// console.log(param)
				for (let i = 0; i < seriesData.length; i++) {
					if (param.name == seriesData[i].name && seriesData[i].stockCode != 0 && seriesData[i].table != 0) {
						_this.mychart.setOption({
							legend: { selected: { [param.name]: true } } //让图例点击后不变灰
						});
						if (seriesData[i].table != 4) {
							this.routerlinkid('/enterprises', seriesData[i].stockCode);
						} else {
							this.routerlinkid('/enterprisesF', seriesData[i].stockCode);
						}
					}
				}
			});
		},
		drawShape(el, data, legendName, unit, type) {
			// console.log(el, data, legendName, unit);

			let Ewidth = type == 'show' ? 20 : 10;
			let xAxisText = [];
			let barData = [], //柱状,
				lineData = []; //折线
			let isFlag = !Array.isArray(data) && Object.keys(data).length > 0 && Object.keys(data).every(key => key.trim() !== '');
			console.log(isFlag);
			if (isFlag) {
				this.$nextTick(() => {
					setTimeout(() => {
						this.barChart(el, data, this.baseInfo.unit, 'show');
					}, 2000)

				})
				return;
			}
			// console.log('没数据',data);
			for (var i = 0; i < data.length; i++) {
				xAxisText.push(data[i].label);
				barData.push(data[i].value);
				lineData.push(data[i].tb);
			}
			// 创建立方体正面图形
			const cubeShape1 = echarts.graphic.extendShape({
				shape: {
					x: 0,
					y: 0,
					width: Ewidth, // 长方体宽度
					zWidth: 2, // 阴影折角高
					zHeight: 4 // 阴影折角宽
				},
				buildPath: (ctx, shape) => {
					const api = shape.api
					const xAxisPoint = api.coord([shape.xValue, 0])
					const p0 = [shape.x, shape.y]
					const p1 = [shape.x - shape.width, shape.y]
					const p4 = [shape.x + shape.width, shape.y]
					const p2 = [
						xAxisPoint[0] - shape.width,
						xAxisPoint[1]
					]
					const p3 = [
						xAxisPoint[0] + shape.width,
						xAxisPoint[1]
					]

					// 绘制正面
					ctx.moveTo(p0[0], p0[1]) //0
					ctx.lineTo(p1[0], p1[1]) //1
					ctx.lineTo(p2[0], p2[1]) //2
					ctx.lineTo(p3[0], p3[1]) //3
					ctx.lineTo(p4[0], p4[1]) //4
					ctx.lineTo(p0[0], p0[1]) //0
					ctx.closePath()
				}
			})

			// 创建立方体的侧面
			const cubeShape2 = echarts.graphic.extendShape({
				shape: {
					x: 0,
					y: 0,
					width: Ewidth, // 长方体宽度
					zWidth: 4, // 阴影折角高
					zHeight: 1 // 阴影折角宽
				},
				buildPath: (ctx, shape) => {
					const api = shape.api
					const xAxisPoint = api.coord([shape.xValue, 0])
					const p4 = [shape.x + shape.width, shape.y]
					const p6 = [
						shape.x + shape.width + shape.zWidth,
						shape.y - shape.zHeight
					]
					const p3 = [
						xAxisPoint[0] + shape.width,
						xAxisPoint[1]
					]
					const p5 = [
						xAxisPoint[0] + shape.width + shape.zWidth,
						xAxisPoint[1] - shape.zHeight
					]

					// 绘制侧面
					ctx.moveTo(p4[0], p4[1]) //4
					ctx.lineTo(p3[0], p3[1]) //3
					ctx.lineTo(p5[0] + 6, p5[1] - 6) //5
					ctx.lineTo(p6[0] + 7, p6[1] - 8) //6
					ctx.lineTo(p4[0], p4[1]) //4
					ctx.closePath()
				}
			})
			// 创建立方体的顶
			const cubeShape3 = echarts.graphic.extendShape({
				shape: {
					x: 0,
					y: 0,
					width: Ewidth,
					zWidth: 4,
					zHeight: 1
				},
				buildPath: (ctx, shape) => {
					const api = shape.api
					const p1 = [shape.x - shape.width, shape.y]
					const p4 = [shape.x + shape.width, shape.y]
					const p6 = [
						shape.x + shape.width + shape.zWidth,
						shape.y - shape.zHeight
					]
					const p7 = [
						shape.x - shape.width + shape.zWidth,
						shape.y - shape.zHeight
					]
					// 绘制顶部
					ctx.moveTo(p4[0], p4[1]) //4
					ctx.lineTo(p6[0] + 7, p6[1] - 8) //6
					ctx.lineTo(p7[0] + 7, p7[1] - 8) //7
					ctx.lineTo(p1[0], p1[1]) //1
					ctx.lineTo(p4[0], p4[1]) //4
					ctx.closePath()
				}
			})

			echarts.graphic.registerShape('cubeShape1', cubeShape1);
			echarts.graphic.registerShape('cubeShape2', cubeShape2);
			echarts.graphic.registerShape('cubeShape3', cubeShape3);
			this.$nextTick(() => {
				this.initECharts(el, xAxisText, lineData, barData, legendName, unit, type);
			})


		},
		initECharts(el, xdata, lineData, barData, legendName, unit) {
			this.mychart = echarts.init(document.getElementById(el));
			this.mychart.clear();

			// 检查数据是否全部为0
			const isBarDataAllZero = barData.every(item => item === 0 || item === null);
			const isLineDataAllZero = lineData.every(item => item === 0 || item === null);

			// 过滤数据：将数值为0的数据点设置为null
			const filteredBarData = barData.map(item => item === 0 ? null : item);
			const filteredLineData = lineData.map(item => item === 0 ? null : item);

			// 动态生成 series 数据
			const series = [];
			if (!isBarDataAllZero) {
				series.push({
					type: 'custom',
					name: legendName + (this.pageType == 2 ? '' : '(' + unit + ')'),
					color: 'rgb(96, 147, 218)',
					renderItem: (params, api) => {
						let location = api.coord([api.value(0), api.value(1)]);
						return {
							type: 'group',
							children: [
								{
									type: 'cubeShape1',
									shape: {
										api,
										xValue: api.value(0),
										yValue: api.value(1),
										x: location[0],
										y: location[1]
									},
									style: {
										fill: 'rgb(96, 147, 218)'
									}
								},
								{
									type: 'cubeShape2',
									shape: {
										api,
										xValue: api.value(0),
										yValue: api.value(1),
										x: location[0],
										y: location[1]
									},
									style: {
										fill: 'rgb(84,128,191)'
									}
								},
								{
									type: 'cubeShape3',
									shape: {
										api,
										xValue: api.value(0),
										yValue: api.value(1),
										x: location[0],
										y: location[1]
									},
									style: {
										fill: 'rgb(104, 161, 236)'
									}
								}
							]
						};
					},
					yAxisIndex: 0,
					data: filteredBarData,
				});
			}
			if (!isLineDataAllZero) {
				series.push({
					name: 'YOY',
					type: 'line',
					yAxisIndex: 1,
					color: '#ffaf25',
					data: filteredLineData
				});
			}

			// 动态生成图例数据
			const legendData = [];
			if (!isBarDataAllZero) {
				legendData.push(legendName + (this.pageType == 2 ? '' : '(' + unit + ')'));
			}
			if (!isLineDataAllZero) {
				legendData.push('YOY');
			}

			const option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					appendToBody: true, // 是否将提示框放置在body元素上
					formatter: function (params) {
						let result = '';
						let name = params[0].name + "</br>";
						let dotHtml = '', dotHtml2 = '', unitd = params[0].componentSubType === "line" ? ' %' : unit;
						if (params[0]) {
							dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[0].color + '"></span> ' + params[0].seriesName + "： " + (params[0].data !== null ? params[0].data : '-') + ' ' + unitd + "</br>";
							if(params[0].seriesName == '()'){
								dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[0].color + '"></span> '+(params[0].data !== null ? params[0].data : '-');
							}
						}
						if (params[1]) {
							dotHtml2 = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[1].color + '"></span>' + params[1].seriesName + "： " + (params[1].data !== null ? params[1].data : '-') + ' %';
						}

						result += name + dotHtml + dotHtml2;
						return result;
					},
				},
				grid: {
					top: '15%',
					right: '10%', // 增加右边距以容纳右侧 Y 轴
					left: '10%', // 增加左边距以容纳左侧 Y 轴
					bottom: '15%',
					containLabel: true
				},
				legend: {
					show: legendData.length > 0 && legendName!='', // 如果没有数据，则不显示图例
					bottom: "5%",
					data: legendData
				},
				xAxis: {
					type: 'category',
					data: xdata,
					interval: 0,
					axisLine: {
						onZero: false,
					},
					axisLabel: {
						interval: 0,
						rotate: xdata.length > 5 ? 45 : 0,
						margin: 15
					}
				},
				yAxis: [
					{
						type: 'value',
						name: '',
						boundaryGap: false,
						axisTick: {
							show: true
						},
						axisLine: {
							show: true,
						},
						splitLine: {
							show: true, // 始终显示背景线
							lineStyle: {
								type: 'dashed' // 虚线样式
							}
						},
					},
					{
						type: 'value',
						name: ' ',
						axisTick: {
							show: true
						},
						splitLine: {
							show: false, // 始终显示背景线
							lineStyle: {
								type: 'dashed' // 虚线样式
							}
						},
						axisLine: {
							show: true,
						},
						axisLabel: {
							formatter: '{value} %'
						}
					}
				],
				series: series
			};

			this.mychart.setOption(option);
		},
		radarChart(el, data, unit) {
			unit = unit ? unit : '';
			this.mychart = echarts.init(document.getElementById(el));
			this.mychart.clear();
			let _this = this;
			let seriesData1 = [], seriesData2 = [];
			for (var i = 0; i < data.length; i++) {
				let tempStr = '';
				if (this.pageType == 1) { //1年度 3月度 4季度
					tempStr = data[i].year + "年";
				} else if (this.pageType == 3) {
					tempStr = data[i].year + '-' + data[i].month + '月';
				} else if (this.pageType == 4) {
					tempStr = data[i].year + '-' + data[i].quarter + '季度';
				}
				data[i].name = tempStr;
				seriesData1.push(data[i].value);
				seriesData2.push(data[i].growth);
			}
			const option = {
				title: {
					text: this.baseInfo.title,
					left: 'center',
				},
				legend: {
					data: [this.baseInfo.title, 'YOY'],
					bottom: 10
				},
				tooltip: {
					show: true
				},
				radar: {
					// shape: 'circle',
					indicator: data,
				},
				series: [
					{
						name: '123213',
						type: 'radar',
						data: [
							{
								value: seriesData1,
								name: _this.baseInfo.title,
								lineStyle: {
									type: 'dashed'
								},

							},
							{
								value: seriesData2,
								name: 'YOY',
								// lineStyle: {
								// color: '#ffaf25'
								// },
								// tooltip: {
								// 	show: true,
								// 	formatter: function (params) {
								// 		return 'YOY :' + params.value + '%';
								// 	}
								// }
							}
						]
					}
				]
			};
			this.mychart.setOption(option)

		},
		barChart(el, data, unit, type) {
			console.log('柱状图', data);
			this.mychart = echarts.init(document.getElementById(el));
			this.mychart.clear();

			// 提取数据
			const labels = [];
			const series = [];
			const yAxisList = []; // 用于存储 Y 轴配置

			// 定义柱状图颜色数组
			const barColors = ['#5470C6', '#91CC75', '#EE6666', '#FAC858', '#73C0DE', '#3BA272', '#FC8452', '#9A60B4', '#E488C1'];
			let barColorIndex = 0; // 用于循环分配柱状图颜色

			// 定义折线图颜色数组
			const lineColors = ['#FAC858', '#73C0DE', '#3BA272', '#FC8452', '#9A60B4', '#E488C1', '#5470C6', '#91CC75', '#EE6666'];
			let lineColorIndex = 0; // 用于循环分配折线图颜色

			// 遍历 dataMap
			for (const key in data) {
				if (data.hasOwnProperty(key)) {
					const dataList = data[key];

					// 提取 label（年份）
					if (labels.length === 0 && dataList && dataList.length > 0) {
						for (let i = 0; i < dataList.length; i++) {
							if (dataList[i].label) {
								labels.push(dataList[i].label);
							}
						}
					}

					// 获取当前数据的单位
					const currentUnit = (dataList && dataList[0] && dataList[0].unit) || '';

					// 根据单位决定图表类型
					const chartType = currentUnit === '%' ? 'line' : 'bar';
					// 为柱状图和折线图分配不同的颜色
					const color = chartType === 'bar' ? barColors[barColorIndex % barColors.length] : lineColors[lineColorIndex % lineColors.length];
					if (chartType === 'bar') {
						barColorIndex++; // 更新柱状图颜色索引
					} else {
						lineColorIndex++; // 更新折线图颜色索引
					}

					// 添加 series
					series.push({
						name: key + ' (' + currentUnit + ')', // 在图例中显示单位
						type: chartType,
						yAxisIndex: yAxisList.length, // 指定 Y 轴索引
						data: dataList.map(function (item) {
							return {
								value: item.data,
								unit: currentUnit // 保存单位到数据点
							};
						}),
						itemStyle: { color: color },
						lineStyle: chartType === 'line' ? {
							width: 3
						} : undefined,
						...(chartType === 'line' ? {
							symbol: 'circle',
							symbolSize: 6
						} : {
							barMaxWidth: 30
						})
					});

					// 添加 Y 轴配置
					yAxisList.push({
						type: 'value',
						name: currentUnit, // Y 轴名称显示单位
						position: chartType === 'line' ? 'right' : 'left', // 折线图 Y 轴在右侧，柱状图 Y 轴在左侧
						axisLabel: {
							formatter: function (value) {
								return value;
							}
						},
						splitLine: {
							show: yAxisList.length === 0, // 只在第一个 Y 轴显示背景刻度线
							lineStyle: {
								type: 'dashed'
							}
						}
					});
				}
			}

			// 检查是否所有数据都是柱状图且单位相同
			const allBarsSameUnit = series.every(s => s.type === 'bar' && s.name.endsWith(`(${unit})`));

			// 如果所有数据都是柱状图且单位相同，只保留一个 Y 轴
			if (allBarsSameUnit) {
				yAxisList.length = 1; // 只保留第一个 Y 轴
				series.forEach(s => {
					s.yAxisIndex = 0; // 将所有系列的 Y 轴索引设置为 0
				});
			}

			// 分离柱状图和折线图的图例
			const barSeries = series.filter(s => s.type === 'bar');
			const lineSeries = series.filter(s => s.type === 'line');
			const legendData = barSeries.map(s => s.name).concat(lineSeries.map(s => s.name));

			// 配置项
			const option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: { type: 'cross' },
					formatter: function (params) {
						var result = params[0].name + '<br/>';
						for (var i = 0; i < params.length; i++) {
							var item = params[i];
							var unit = (item.data && item.data.unit) || '';
							result += item.marker + ' ' + item.seriesName.split(' (')[0] + ': ' + item.value + ' ' + unit + '<br/>';
						}
						return result;
					}
				},
				legend: {
					data: legendData, // 柱状图图例在前，折线图图例在后
					bottom: 10,
					itemGap: 20
				},
				grid: {
					top: '15%',
					right: '10%', // 增加右边距以容纳右侧 Y 轴
					left: '10%', // 增加左边距以容纳左侧 Y 轴
					bottom: '15%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					data: labels,
					axisLabel: {
						interval: 0,
						rotate: labels.length > 5 ? 45 : 0,
						margin: 15
					}
				},
				yAxis: yAxisList, // 使用动态生成的 Y 轴配置
				series: series
			};

			this.mychart.setOption(option);
		},
		//params 要处理的字符串
		//length 每行显示长度
		getEqualNewlineString(params, length) {
			let text = ''
			let count = Math.ceil(params.length / length) // 向上取整数
			// 一行展示length个
			if (count > 1) {
				for (let z = 1; z <= count; z++) {
					text += params.substr((z - 1) * length, length)
					if (z < count) {
						text += '\n'
					}
				}
			} else {
				text += params.substr(0, length)
			}
			return text
		},
		// 导出多张图表为一张图片
		// dmo元素里的内容转换为canvas,并将canvas下载为图片
		download() {
			// 转换成canvas
			html2canvas(document.getElementById("baseInfoCharts")).then(function (canvas) {
				var img = canvas
					.toDataURL("image/png")
					.replace("image/png", "image/octet-stream");
				// 创建a标签，实现下载
				var creatIMg = document.createElement("a");
				creatIMg.download = "图表.png"; // 设置下载的文件名，
				creatIMg.href = img; // 下载url
				document.body.appendChild(creatIMg);
				creatIMg.click();
				creatIMg.remove(); // 下载之后把创建的元素删除
			});
		},
	}
}
</script>

<style>
#baseInfoCharts {
	width: 95%;
	height: 700px;
	/* border: 1px solid red; */
	margin: 0 auto;
}
.charts-title {
	font-size: 22px;
	letter-spacing: 2px;
	font-weight: bold;
	padding-bottom: 30px;
	/* border-bottom: 1px solid #ececec; */
	margin-bottom: 20px;
	
}

.market-chain-img {
	width: 95%;
	margin: 0 auto;
	padding-bottom: 10px;
}

.download-position {
	position: relative;

}

.download-position .downloadPng {
	cursor: pointer;
	position: absolute;
	right: 11%;
	top: 80px;
	z-index: 99;
}
</style>